<template>
  <Avatar :userName="label" :showSingleLetter="true" size="small" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Avatar } from '@tallo/design-system';
import { getFullName } from '@tallo/utility';

import { ShowingAgentDto } from '../interfaces/showing-agent.dto';

const props = defineProps<{
  showingAgent: ShowingAgentDto;
}>();

const label = computed(() => getFullName(props.showingAgent));
</script>

<style scoped lang="scss"></style>
